const API_KEY = ""; // CodeSandbox inyectará la clave

export const callGemini = async (prompt, systemInstruction = "") => {
  const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${API_KEY}`;

  const payload = {
    contents: [{ parts: [{ text: prompt }] }],
    systemInstruction: {
      parts: [
        {
          text:
            systemInstruction ||
            "Eres un experto en leyes de bienes raíces de Panamá. Responde de forma concisa y educativa.",
        },
      ],
    },
  };

  for (let i = 0; i < 5; i++) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      return (
        data.candidates?.[0]?.content?.parts?.[0]?.text ||
        "Error al procesar la respuesta."
      );
    } catch (e) {
      await new Promise((res) => setTimeout(res, Math.pow(2, i) * 1000));
    }
  }
  return "No se pudo conectar con el Tutor IA. Por favor, intenta más tarde.";
};
